<template>
    <!-- <div class="item-grid-view vx-row match-height">
        <div class="vx-col" :class="gridColumnWidth" v-for="item in items" :key="item.objectID"> -->
            <vx-card class="grid-view-item mb-base overflow-hidden">
                <template slot="no-body">

                    <!-- ITEM IMAGE -->
                    <div class="item-img-container bg-white h-64 flex items-center justify-center mb-4">
                        <img :src="item.cover" :alt="item.name" class="grid-view-img px-4">
                    </div>
                    <div class="item-details px-4">

                        <!-- RATING & PRICE -->
                        <div class="flex justify-between items-center">
                            <div class="bg-primary flex text-white py-1 px-2 rounded">
                                <span class="text-sm mr-2">{{ item.hour }} 课时</span>
                                <feather-icon icon="ClockIcon" svgClasses="h-4 w-4" />
                            </div>
                            <div class="bg-primary flex text-white py-1 px-2 rounded"
                              :class="item.grant ? 'bg-success': 'bg-danger'"
                            >
                                <span class="text-sm" v-if="item.grant">已开通</span>
                                <span class="text-sm" v-else>未开通</span>
                            </div>
                        </div>

                        <!-- TITLE & DESCRIPTION -->
                        <div class="my-4">
                            <h6 class="truncate font-semibold mb-1">{{ item.name }}</h6>
                            <p class="item-description truncate">课程简介：{{ item.brief }}</p>
                        </div>

                        <div class="my-4">
                            <span class="subject-item mr-2">{{ item.subject.name }}</span>
                            <span class="subject-item">{{ item.cate.name }}</span>
                        </div>
                    </div>

                    <!-- SLOT: ACTION BUTTONS -->
                    <slot name="action-buttons" />
                </template>
            </vx-card>
       <!--  </div>
    </div> -->
</template>

<script>
export default{
    props: {
        item: {
            type: Object,
            required: true
        },
    },
}
</script>

<style lang="scss" scoped>
.grid-view-item {
    .grid-view-img {
        // max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        // transform: translateY(-5px);
        box-shadow: 4px 4px 25px 0px rgba(78, 78, 78, 0.25);

        .grid-view-img{
            opacity: 0.9;
        }        
    }
}
.subject-item {
    display: inline-block;
    padding: 0.2rem 0.5rem;
    font-size: 12px;
    color: #5c5c5c;
    border: 1px solid #ccc;
    border-radius: 6px;
    transition: .5s;
}
.vx-card {
    box-shadow: none !important;
}
</style>